module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_vm._v("The Eat Fit Zero Proof Story")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crafting the Zero Proof Cocktail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Art + Science of Sweeteners + Simple Syrups")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DIY Infusions | Bitters, Shrubs + Simple Syrups")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glassware")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garnishes + Embellishments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zero Proof Picks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Drinks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Orleans + Classics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herbal + Florals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet + Spicy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11#C11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Highballs + Collinses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter12#C12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fizzes, Flips + Smashes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13#C13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toddies + Teas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter14#C14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tiki + Tropical")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0